import { WidgetType, WidgetView } from '../types';

export const CALENDAR_TYPE_SEARCH_PARAM: string = 'calendar-type';
export const DEFAULT_CALENDAR_TYPE: WidgetType = 'list';

export const CALENDAR_VIEW_SEARCH_PARAM: string = 'calendar-view';
export const DEFAULT_CALENDAR_VIEW: WidgetView = 'month';

export const CALENDAR_CURRENT_MONTH_SEARCH_PARAM: string = 'month';

export const SENTRY_DSN: string = 'https://11e064cf570640c2a571bf40f6a60881@sentry.uncinc.nl/54';

export const OUTLOOK_INFO: string = 'https://support.office.com/nl-nl/article/Internetkalenders-bekijken-en-een-abonnement-erop-nemen-f6248506-e144-4508-b658-c838b6067597#bm2';
export const MOZILLA_LIGHTNING_INFO: string = 'https://support.mozilla.org/nl/kb/een-feestdagenkalender-toevoegen#w_abonneren-op-een-externe-kalender';
